import { autoRegisterFeature } from '@store/features/factory';

import { patientCoveragesFeature } from './store/feature';

// Auto-register the feature
autoRegisterFeature(patientCoveragesFeature);

// Export everything from store
export * from './store';

// Export types
export * from './types';

// Export eligibility status config utilities
export type { StatusConfig } from './eligibilityStatusConfig';
export { STATUS_CONFIG } from './eligibilityStatusConfig';
